import React, { useContext, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { UserContext } from '../context/UserContext';
import { ProfileContext } from '../context/ProfileContext';
import analytics, {
  USER_PROFILE_FETCH_ERROR_ACTION,
  ERROR_CATEGORY,
} from '../analytics';
import { getUserAuth } from '../utils/authentication';

const UserProfileFetchAlert = () => {
  const { fetchError: userFetchError } = useContext(UserContext);
  const { fetchError: profileFetchError } = useContext(ProfileContext);

  useEffect(() => {
    if (userFetchError) {
      trackError('user', userFetchError);
    }
  }, [userFetchError]);

  useEffect(() => {
    if (profileFetchError) {
      trackError('profile', profileFetchError);
    }
  }, [profileFetchError]);

  function trackError(apiName: string, errorMessage: string) {
    const { username, isEmployer, isStaff } = getUserAuth();

    analytics.Events.trackEvent({
      actionType: USER_PROFILE_FETCH_ERROR_ACTION,
      category: ERROR_CATEGORY,
      payload: {
        userId: username ?? null,
        role: isEmployer ? 'employer' : isStaff ? 'staff' : 'unknown',
        failedApi: apiName,
        errorMessage: errorMessage,
      },
    });
  }

  return (
    <Alert
      isOpen={!!userFetchError || !!profileFetchError}
      color="danger"
      fade={false}
      className="rounded-0"
    >
      We're having trouble loading your account information right now. Please
      refresh the page to try again. If this keeps happening, reach out to our
      support team and we'll be happy to help.
    </Alert>
  );
};

export default UserProfileFetchAlert;
